import { animate, style, transition, trigger } from '@angular/animations';

export const toggleAnimations = [
    trigger('toggleAnimation', [
        transition(':enter', [
            style({ 'max-height': `0px`, 'opacity': 0 }),
            animate('500ms ease-in-out', style({ 'max-height': `500px`, 'opacity': 1 })),
        ]),
        transition(':leave', [
            style({ 'opacity': 1, 'max-height': `500px`, 'height': '{{mediaHeight}}', 'filter': 'blur(2px)' }),
            animate('300ms ease-in-out', style({ 'max-height': `0px`, 'opacity': 0 })),
        ]),
    ]),
];
